import React from 'react';
import { devLog, devWarn, devError } from '../utils/devLogger';
import AnimatedBorderButton from './AnimatedBorderButton';

const AnimatedBorderButtonDemo: React.FC = () => {
  const handleComplete = () => {
    devLog('버튼 완료!');
    alert('애니메이션이 완료되었습니다!');
  };

  const handleIncomplete = () => {
    devLog('버튼 미완료');
  };

  const handleDisabled = () => {
    devLog('버튼 비활성화됨');
    alert('버튼이 비활성화되어 있습니다.');
  };

  return (
    <div style={{ 
      padding: '50px', 
      display: 'flex', 
      flexDirection: 'column', 
      gap: '30px',
      alignItems: 'center',
      backgroundColor: '#f5f5f5',
      minHeight: '100vh'
    }}>
      <h2 style={{ color: '#333', marginBottom: '20px' }}>애니메이션 보더 버튼 데모</h2>
      
      {/* 기본 버튼 */}
      <div style={{ textAlign: 'center' }}>
        <h3>기본 버튼 (2초)</h3>
        <AnimatedBorderButton
          title="길게 눌러주세요"
          onPressed={handleComplete}
          onIncomplete={handleIncomplete}
          duration={2}
        />
      </div>

      {/* 빠른 버튼 */}
      <div style={{ textAlign: 'center' }}>
        <h3>빠른 버튼 (1초)</h3>
        <AnimatedBorderButton
          title="빠른 완료"
          onPressed={handleComplete}
          onIncomplete={handleIncomplete}
          duration={1}
          finalBorderColor="#28a745"
          textPressedColor="#28a745"
          textCompletedColor="#155724"
        />
      </div>

      {/* 긴 버튼 */}
      <div style={{ textAlign: 'center' }}>
        <h3>긴 버튼 (3초)</h3>
        <AnimatedBorderButton
          title="천천히 눌러주세요"
          onPressed={handleComplete}
          onIncomplete={handleIncomplete}
          duration={3}
          width={250}
          height={70}
          finalBorderColor="#dc3545"
          textPressedColor="#dc3545"
          textCompletedColor="#721c24"
        />
      </div>

      {/* 커스텀 스타일 버튼 */}
      <div style={{ textAlign: 'center' }}>
        <h3>커스텀 스타일</h3>
        <AnimatedBorderButton
          title="커스텀 버튼"
          onPressed={handleComplete}
          onIncomplete={handleIncomplete}
          duration={2}
          width={180}
          height={50}
          borderRadius={25}
          borderThickness={3}
          backgroundColor="#fff"
          finalBorderColor="#6f42c1"
          textColor="#6f42c1"
          textPressedColor="#fff"
          textCompletedColor="#fff"
        />
      </div>

      {/* 비활성화된 버튼 */}
      <div style={{ textAlign: 'center' }}>
        <h3>비활성화된 버튼</h3>
        <AnimatedBorderButton
          title="비활성화됨"
          onPressed={handleComplete}
          onIncomplete={handleIncomplete}
          disabledCallback={handleDisabled}
          duration={2}
          disabled={true}
        />
      </div>

      <div style={{ 
        marginTop: '20px', 
        padding: '20px', 
        backgroundColor: '#fff', 
        borderRadius: '8px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        maxWidth: '600px'
      }}>
        <h4 style={{ color: '#333', marginBottom: '10px' }}>사용법:</h4>
        <ul style={{ color: '#666', fontSize: '14px', lineHeight: '1.5' }}>
          <li>마우스나 터치로 버튼을 길게 눌러주세요</li>
          <li>시계방향으로 보더가 채워지면서 애니메이션이 진행됩니다</li>
          <li>지정된 시간(duration) 동안 누르고 있으면 완료됩니다</li>
          <li>중간에 떼면 애니메이션이 초기화됩니다</li>
        </ul>
      </div>
    </div>
  );
};

export default AnimatedBorderButtonDemo;
